import {
  Button,
  DatePicker,
  Row,
  Select,
  Space,
  Table,
  notification,
} from "antd";
import React, {useEffect, useRef, useState} from "react";
import {columnHistory} from "./HistoryPay.config";
import {payService, storeService} from "api";
import Icon from "assets/icons";
import {useAppSelector} from "redux/hooks";
import BillModal from "./BillModal/BillModal";
import dayjs from "dayjs";
import Notification from "components/common/notification/notification";
import {FORMAT_TIME} from "types/enums";
import {ListActionButton, ModalCustom} from "components/common";
import {jsonParse} from "helper/common";
import {getListHinhThucThanhToan} from "helper/call-api-list";
import ModalPrint from "./ModalPrint/ModalPrint";

interface InsuranceDataType {
  coTheBhyt: boolean | null;
  maTheBhyt: string | null;
  hoTenTrenThe: string | null;
  ngaySinhTrenThe: string | null;
  the5Nam: string | null;
  diaChiTrenThe: string | null;
  ngayBatDau: string | null;
  ngayKetThuc: string | null;
  noiDkkcbd: string | null;
  maNoiDkkcbbd: string | null;
  chucVu: string | null;
  donVi: string | null;
  nguoiCapNhatThe: string | null;
  ngayCapNhatThe: string | null;
  trangThaiBH: number | null;
  phanTramMienGiam: number | null;
}

const HistoryPay = () => {
  const [data, setData] = useState([]);
  const [loadingTable, setLoadingTable] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const examRef = useRef<any>();
  const idLanKham = useAppSelector(state => state.reduxCommon.id);
  const callApi = useAppSelector(state => state.reduxCommon.callApi);
  const [isShowModal, setIsShowModal] = useState(false);
  const [listPayments, setListpayments] = useState<any>();
  const [idPrint, setIdPrint] = useState();
  const printRef = useRef(null);

  useEffect(() => {
    getListHistory();
  }, [currentPage, idLanKham, callApi]);

  const getListHistory = async () => {
    try {
      const response = await payService
        .getHistoryPay(idLanKham, currentPage)
        .then(res => {
          // console.log("response lich su thanh toán", res);
          const newData = res.data.data.map(item => ({
            key: item.id,
            id: item.id,
            soPhieuThu: item.soPhieuThu,
            noiDung: item.noiDungThu,
            ngayPhieuThu: item.ngayPhieuThu,
            soTien: item.soTienGiaoDich,
            soTienTraLai: item.soTienTraLai,
            maGiaoDich: item.maGiaoDich,
            hinhThucTT: item.idHinhThucThanhToan,
            nguoiThu: item.tenNhanVien,
          }));
          setData(newData?.sort((a, b) => a?.id - b?.id));
          setLoadingTable(false);
          setTotalPage(res.data.total);
        });
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi lấy danh sách lịch sử thanh toán"
      );

      setLoadingTable(false);
    }
  };
  // useEffect(() => {
  //   const _setListPayments = async () => {
  //     if (jsonParse(localStorage.getItem("hinhThucThanhToan"))?.length > 0) {
  //       setListpayments(jsonParse(localStorage.getItem("hinhThucThanhToan")));
  //     } else {
  //       const _listPaymenst = await getListHinhThucThanhToan();
  //       setListpayments(_listPaymenst);
  //     }
  //   };
  //   _setListPayments();
  // }, []);
  columnHistory.map(column => {
    if (column.dataIndex == "hinhThucTT") {
      column.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <Select
          allowClear={false}
          style={{width: "100%"}}
          value={value ?? null}
          onChange={e =>
            setData(prevDataTable => {
              return prevDataTable.map(prevItem =>
                prevItem.id === record.id
                  ? {
                      ...prevItem,
                      hinhThucTT: e ?? null,
                    }
                  : prevItem
              );
            })
          }
          options={[
            {value: 0, label: "Tiền mặt"},
            {value: 1, label: "Chuyển khoản"},
            {value: 2, label: "Quẹt thẻ"},
          ]}
        ></Select>
      );
    }
    if (column.dataIndex == "ngayPhieuThu") {
      column.render = (value, record, index) => (
        // <span>{localStorage.getItem("username")}</span>
        <DatePicker
          style={{width: "100%"}}
          value={value ? dayjs(value) : null}
          format={`${FORMAT_TIME.dayFull}`}
          showTime={true}
          onChange={e =>
            setData(prevDataTable => {
              return prevDataTable.map(prevItem =>
                prevItem.id === record.id
                  ? {
                      ...prevItem,
                      ngayPhieuThu: e ? dayjs(e) : null,
                    }
                  : prevItem
              );
            })
          }
        ></DatePicker>
      );
    }

    if (column.dataIndex == "action") {
      column.render = (value, record, index) => (
        <ListActionButton
          saveFunction={() => handleOnSave(record)}
          printFunction={
            record?.noiDung !== "Hủy thanh toán"
              ? () => {
                  printPhieuThuLe(record?.id);
                }
              : undefined
          }
        ></ListActionButton>
      );
    }
  });
  const printPhieuThuLe = id => {
    setIdPrint(id);
    printRef?.current?.openModal();
  };
  const handlePaginationChangeList = page => {
    setCurrentPage(page);
  };

  const paginationConfig = {
    current: currentPage,
    total: totalPage,
    onChange: handlePaginationChangeList,
  };

  const handleOnSave = async body => {
    const newData = {
      id: body.id,
      ngayPhieuThu: dayjs(body.ngayPhieuThu).valueOf(),
      idHinhThucThanhToan: body?.hinhThucTT,
    };
    // console.log('adsaddsa', newData);
    setLoadingTable(true);
    try {
      const response = await payService.saveHistoryPay(newData).then(res => {
        Notification("success", "Lưu thông tin thành công");
        setLoadingTable(false);
        getListHistory();
      });
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi lưu lịch sử thanh toán");

      setLoadingTable(false);
    }
  };

  const handleOk = () => {
    setIsShowModal(false);
  };

  const handleCancel = () => {
    setIsShowModal(false);
    // setApiCalled(false);
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const rowSelection = {
    selectedRowKeys,
    onChange: async (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      // setSelectedRows(selectedRows);
      // const newArr = selectedRows.map((item) => item.id);
      // setListId(newArr);
      const selectedRowStatuses = selectedRows.filter(row => row.status == 0);
      // setDataPay(selectedRowStatuses);
    },
    getCheckboxProps: (record: any) => ({
      name: record.name,
    }),
  };

  return (
    <div>
      <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
        {/* <Row justify={"end"} gutter={[16,8]}>
          <Button
            type="primary"
            // className="btn-sub"
            icon={<Icon.save rev={0} />}
            onClick={handleOnSave}
          >Lưu</Button>
        </Row> */}
        <Table
          bordered
          dataSource={data}
          columns={columnHistory}
          pagination={paginationConfig}
          // rowSelection={{
          //   ...rowSelection,
          // }}
        ></Table>
      </Space>
      {/* <BillModal
        isShowModal={isShowModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
      /> */}
      <ModalCustom
        ref={printRef}
        onCloseModal={() => {
          setIdPrint(null);
        }}
      >
        <ModalPrint idPrint={idPrint}></ModalPrint>
      </ModalCustom>
    </div>
  );
};

export default HistoryPay;
